<div (click)="onClicked()" class="flex flex-row items-center gap-2 p-2 hover:bg-ponder-linkhover hover:bg-opacity-15 hover:cursor-pointer text-sm" [ngClass]="{ 'rounded-b-md' : isLast, 'border-b-[1px]' : !isLast, 'bg-ponder-linkhover bg-opacity-20' : isSelected }">
    <svg class="w-5 h-5 fill-none stroke-ponder-light" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
        <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="svgIconStr" />
    </svg>
    <span>{{ label }}</span>
</div>